// @flow

import * as React from "react";
import classNames from "classnames";
import SlickSlider from "react-slick";

import Arrow from "./arrow";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./styles.scss";

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: true,
  nextArrow: <Arrow type="next" />,
  prevArrow: <Arrow type="prev" />,
  fade: true,
};

type Props = {
  className?: string,
  children: React.Node,
  enableKeyboardControll?: boolean,
};

class Slider extends React.Component<Props> {
  sliderWrapper: *;
  slider: *;

  componentDidMount() {
    setTimeout(() => {
      if (this.sliderWrapper) {
        this.sliderWrapper.focus();
      }
    }, 1000);
  }

  onKeyBoardControll = (event: any) => {
    if (this.props.enableKeyboardControll && this.slider) {
      if (event.keyCode === 39) {
        this.slider.slickNext();
      }
      if (event.keyCode === 37) {
        this.slider.slickPrev();
      }
    }
  };

  render() {
    return (
      <div
        onKeyUp={this.onKeyBoardControll}
        className={classNames("default-slider", this.props.className)}
        ref={ref => (this.sliderWrapper = ref)}
      >
        <SlickSlider ref={ref => (this.slider = ref)} {...settings}>
          {this.props.children}
        </SlickSlider>
      </div>
    );
  }
}

export default Slider;
